import { Controller } from "@hotwired/stimulus"

// Copies the text content of a `source` target to the clipboard and flashes the
// trigger button.
export default class extends Controller {
  static targets = ["source"]

  copy(event) {
    const button = event.currentTarget
    const text = this.hasSourceTarget ? this.sourceTarget.textContent : ""
    navigator.clipboard.writeText(text).then(() => this.flash(button))
  }

  flash(button) {
    if (!button) return
    const label = button.querySelector(".clipboard-label")
    const icon = button.querySelector("i")
    const prevLabel = label ? label.textContent : null
    if (label) label.textContent = "Copied"
    if (icon) { icon.classList.remove("bi-clipboard"); icon.classList.add("bi-check-lg") }
    setTimeout(() => {
      if (label && prevLabel) label.textContent = prevLabel
      if (icon) { icon.classList.remove("bi-check-lg"); icon.classList.add("bi-clipboard") }
    }, 1500)
  }
}
